import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

import addMonths from 'date-fns/addMonths';
import startOfHour from 'date-fns/startOfHour';
import endOfHour from 'date-fns/endOfHour';
import { Container } from '../components/MenuBar';
import NavGroup from '../components/MenuBar/NavGroup';
import { useAccountId } from '../auth/useAccountId';
import { Allow } from '../auth/accessToken';

const MenuInternal = (
    {
        t,
        accountId,
    }: {
        t: TFunction;
        accountId: string;
    }
) => (<Container>
    <NavGroup
        mainLink={{
            path: `/${accountId}/payments/transactions`,
            label: t('payments.menu.transactions'),
        }}
        subLinks={[
            {
                path:
                    `/${accountId}/payments/transactions?status=AUTHORIZED&status=PARTIALLY_CAPTURED` +
                    `&created_at.gte=${startOfHour(addMonths(new Date(), -12)).toISOString()}` +
                    `&created_at.lte=${endOfHour(addMonths(new Date(), 1)).toISOString()}`,
                label: t('payments.menu.open_transactions'),
            },
            {
                path: `/${accountId}/payments/transactions?status=DECLINED`,
                label: t('payments.menu.declined_transactions'),
            },
        ]}
    />
    <NavGroup
        mainLink={{
            path: `/${accountId}/reports/settlements`,
            label: t('payments.menu.payouts'),
        }}
        subLinks={[]}
    />
    <Allow anyOfScopes={[['admin'], ['admin:checkout'], ['write:checkout']]}>
        <NavGroup
            mainLink={{
                path: `/${accountId}/payments/virtual-terminal`,
                label: t('payments.menu.virtual_terminal'),
            }}
            subLinks={[]}
        />
    </Allow>
    <NavGroup
        mainLink={{
            path: `/${accountId}/payments/sessions`,
            label: t('payments.menu.sessions'),
        }}
        subLinks={[
            {
                path: `/${accountId}/payments/sessions?initiating_system.dintero_system_plugin_name=backoffice-digital-terminal-v2&initiating_system.dintero_system_plugin_name=backoffice-digital-terminal-v1`,
                label: t('payments.menu.virtual_terminal_filter'),
            },
        ]}
    />
</Container>);

const MenuInternalMemo = memo(MenuInternal);

const Menu = () => {
    const { t } = useTranslation();
    const accountId = useAccountId();
    return <MenuInternalMemo t={t} accountId={accountId} />;
};

export default Menu;
